import React from 'react';
import { SolutionsIntro } from '../components/solutions/SolutionsIntro';
import { SolutionSettings } from '../components/solutions/SolutionSettings';
import { SolutionsCycle } from '../components/solutions/SolutionsCycle';
export function SolutionsPage() {
  return <>
      <SolutionsIntro data-id="element-2323" data-mp="12jvcyv5wujdy" />
      <SolutionSettings data-id="element-2324" data-mp="12k56gsq5z8oe" />
      <SolutionsCycle data-id="element-2325" data-mp="12ike99rbo1tp" />
    </>;
}